import React from 'react';
import ShipmentDelivery from '../ShipmentDelivery';
import ShipmentCard from '../ShipmentCard';
import { INewCartShipment } from 'pages/NewCart/ICart';
import useOOSSubstitute from 'hooks/useOOSSubstitute';

import * as S from './ShipmentListItem.style';

const ShipmentListItem: React.FC<{
  busyHourDisclaimer: string;
  shipment: INewCartShipment;
  isNowOfflineHour: boolean;
  isNowUnavailableHour: boolean;
  nextAvailableSlot: any;
  totalShipments: number;
}> = ({
  busyHourDisclaimer,
  shipment,
  isNowOfflineHour = false,
  isNowUnavailableHour = false,
  nextAvailableSlot = {},
  totalShipments,
}) => {
  const isOOSSubstitutionEnabled = useOOSSubstitute();

  return (
    <S.ShipmentListItem>
      <ShipmentDelivery
        busyHourDisclaimer={busyHourDisclaimer}
        deliveryPromise={shipment.deliveryPromiseInfo ? shipment.deliveryPromiseInfo.promise : ''}
        isNowOfflineHour={isNowOfflineHour}
        isNowUnavailableHour={isNowUnavailableHour}
        nextAvailableSlot={nextAvailableSlot}
        shipmentType={shipment.shipmentType}
        isShipmentOOS={shipment.entries.length === 0}
      />

      <ShipmentCard
        isNowUnavailableHour={isNowUnavailableHour}
        shipment={shipment}
        totalShipments={totalShipments}
        isOOSSubstitutionEnabled={isOOSSubstitutionEnabled}
      />
    </S.ShipmentListItem>
  );
};

export default ShipmentListItem;
